import { Platform } from '@angular/cdk/platform';
import { PageOptions } from './data-table.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTableService {

  private readonly defaultPageOptions: PageOptions = {
    page: 0,
    size: this.platform.TRIDENT ? 50 : 300,
    sort: '',
    order: 'asc'
  };

  constructor(
    private readonly platform: Platform
  ) { }

  pageOptionsDefault(options?: any): PageOptions {
    return {
      ...this.defaultPageOptions,
      ...options
    };
  }

  pageOptionsDefaultSort(sort: string, order: 'asc' | 'desc' | 'none' = 'asc'): PageOptions {
    return {
      ...this.defaultPageOptions,
      sort,
      order
    };
  }
}
